/* global GOOGLE_API_KEY:true */
import React, { Component } from "react";
import router from "umi/router";
import { EnvironmentOutlined, DeleteOutlined } from "@ant-design/icons";
import { PageHeaderWrapper, PageLoading } from "@ant-design/pro-layout";
import { Result, message, Badge, Card, Descriptions, Divider, Button, Steps, Modal, Row, Col, Alert, Tag } from "antd";
import { connect } from "dva";
import GoogleMapReact from "google-map-react";
import moment from "moment-timezone";
import { Link } from "umi";
import { formatPhoneNumber, quoteDeletetionReasonsMap, DEFAULT_ID } from "@/utils/utils";
import VehicleDescription from "@/components/VehicleDescription";
import QuotesEditForm from "../QuotesEditForm";
import QuotesForm from "../QuotesForm";

const { confirm } = Modal;

const { Step } = Steps;

// Inline styles
const cardHead = { color: "white", backgroundColor: "#22316C" };
const grid = { md: { span: 12 }, sm: { span: 24 } };

// const capitalize = s => {
//   if (typeof s !== 'string') return '';
//   return s.charAt(0).toUpperCase() + s.slice(1);
// };

class SingleQuote extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const { dispatch } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const vehicleId = urlParams.get("vehicleId");
    const quoteId = urlParams.get("quoteId");

    if (vehicleId) {
      dispatch({
        type: "quotesView/fetchSingleQuoteByVehicleId",
        payload: { vehicleId },
      });
    } else if (quoteId) {
      dispatch({
        type: "quotesView/fetchSingleQuoteByQuoteId",
        payload: { quoteId },
      });
    }
  }

  onClickLoad = () => {
    const { quotesView } = this.props;
    const quotesData = quotesView.data;
    const urlParams = new URLSearchParams(window.location.search);
    const entityId = urlParams.get("entityId");
    router.push(
      `/shipments/view/load?shipmentId=${quotesData.vehicle.shipmentId}&loadId=${quotesData.vehicle.loadId}&entityId=${entityId}`,
    );
  };

  onClickShipment = () => {
    const { quotesView } = this.props;
    const quotesData = quotesView.data;
    const urlParams = new URLSearchParams(window.location.search);
    const entityId = urlParams.get("entityId");
    router.push(`/shipments/view?shipmentId=${quotesData.vehicle.shipmentId}&entityId=${entityId}`);
  };

  handleDeleteQuote = quoteId => {
    const { dispatch } = this.props;

    confirm({
      title: "Delete Quote?",
      content: "Are you sure you want to delete this quote? This action cannot be undone.",
      onOk() {
        const hide = message.loading("Deleting");
        dispatch({
          type: "quotesView/adminRemoveQuote",
          payload: { id: quoteId },
        }).then(() => {
          message.success("Quote successfully deleted");
          hide();
          router.push(`/admin/quotes`);
        });
      },
    });
  };

  extraActionButtons = () => {
    const { quotesView, configPerm } = this.props;
    const quotesData = quotesView.data;

    const hasShipment = quotesData?.vehicle?.shipment;

    return (
      <>
        {configPerm["CoreService.Quotes"] && (
          <>
            {!quotesData.deleted && quotesData.status === 0 && configPerm["CoreService.Quotes.Delete"] && (
              <Button
                type="danger"
                onClick={() => this.handleDeleteQuote(quotesData.quoteId)}
                icon={<DeleteOutlined />}
                style={{
                  display: configPerm["CoreService.Quotes.Delete"] ? "inline-block" : "none",
                }}
              >
                Delete Quote
              </Button>
            )}
            {!quotesData.deleted && quotesData.status === 1 && hasShipment && (
              <QuotesEditForm
                quoteId={quotesData.quoteId}
                dealerPrice={quotesData.dealerPrice}
                transporterPrice={quotesData.transporterPrice}
                dealerPriceReason={quotesData.dealerPriceReason}
                transporterPriceReason={quotesData.transporterPriceReason}
                style={{ display: "inline-block" }}
              />
            )}
          </>
        )}
      </>
    );
  };

  extraMapRenders = (map, maps) => {
    const { quotesView } = this.props;
    const data = quotesView.data;
    let directionsService = new maps.DirectionsService();
    let directionsRender = new maps.DirectionsRenderer();
    directionsRender.setMap(map);
    directionsService.route(
      {
        origin: `${data.shipment.pickupLatitude},${data.shipment.pickupLongitude}`,
        destination: `${data.shipment.dropoffLatitude},${data.shipment.dropoffLongitude}`,
        travelMode: "DRIVING",
      },
      function (response, status) {
        if (status === "OK") {
          directionsRender.setDirections(response);
        } else {
          window.alert("Directions request failed due to " + status);
        }
      },
    );
  };

  midPintCalculation = (pickupCoord, dropoffCoord) => {
    return (pickupCoord + dropoffCoord) / 2;
  };

  printUserFullNameLink = quotesData => {
    if (!quotesData.deletedBy) return "";

    const firstName = quotesData.deletedBy.firstName || "";
    const lastName = quotesData.deletedBy.lastName || "";
    const userId = quotesData.deletedBy.userId;
    const fullName = `${firstName} ${lastName}`;

    return userId && userId !== DEFAULT_ID ? (
      <Link to={`/admin/users/view?userId=${userId}`} target="_blank" rel="noopener noreferrer">
        {fullName}
      </Link>
    ) : (
      fullName
    );
  };

  render() {
    const { quotesView, loadingByVehicleId, loadingByQuoteId, configPerm } = this.props;
    const quotesData = quotesView.data;

    const hasShipment = quotesData?.vehicle?.shipment;
    const urlParams = new URLSearchParams(window.location.search);
    const vehicleId = urlParams.get("vehicleId");
    const quoteId = urlParams.get("quoteId");

    if (quoteId && (typeof loadingByQuoteId === "undefined" || loadingByQuoteId === true)) {
      return <PageLoading />;
    }

    if (vehicleId && (typeof loadingByVehicleId === "undefined" || loadingByVehicleId === true)) {
      return <PageLoading />;
    }

    if (!quotesData?.quoteId) {
      return (
        <PageHeaderWrapper onBack={() => window.history.back()} title={`Quote Detail: Error`}>
          <Card bordered={false}>
            <Result status="error" title="Error fetching quote" />
          </Card>
        </PageHeaderWrapper>
      );
    }

    return (
      <PageHeaderWrapper
        onBack={() => window.history.back()}
        title={`Quote Detail: ${quotesData.quoteId.split("-")[0].toUpperCase()}`}
        extra={this.extraActionButtons()}
        tags={quotesData.deleted && <Tag color="red">Deleted</Tag>}
      >
        <Card bordered={false}>
          <Row gutter={[16, 16]} justify="space-between">
            <Col {...grid}>
              <Card type="inner" title="Quote" style={{ height: "100%" }} headStyle={cardHead} className={"noPadding"}>
                <Descriptions
                  style={{
                    marginBottom: 32,
                  }}
                  column={1}
                  bordered
                >
                  <Descriptions.Item key="status" label="Status" style={{ fontWeight: 600 }}>
                    {quotesData.status === 0 ? (
                      <QuotesForm disabled={quotesData.deleted} quotesData={quotesData} />
                    ) : (
                      <Badge status="success" text="Complete" style={{ fontWeight: 600 }} />
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item key="createdAt" label="Created at" style={{ fontWeight: 600 }}>
                    {moment.utc(quotesData.createdAt).locale("en").local().format("dddd, MMMM Do YYYY, h:mm a")}
                  </Descriptions.Item>
                  <Descriptions.Item key="dealerPrice" label="Dealer Price" style={{ fontWeight: 600 }}>
                    ${quotesData.dealerPrice ? quotesData.dealerPrice : "0.00"}
                  </Descriptions.Item>
                  {configPerm["CoreService.Quotes.Edit"] && (
                    <React.Fragment>
                      <Descriptions.Item key="transporterPrice" label="Transporter Price" style={{ fontWeight: 600 }}>
                        ${quotesData.transporterPrice ? quotesData.transporterPrice : "0.00"}
                      </Descriptions.Item>
                      <Descriptions.Item key="autosledProfit" label="Autosled Profit" style={{ fontWeight: 600 }}>
                        ${quotesData.autosledProfit ? quotesData.autosledProfit : "0.00"}
                      </Descriptions.Item>
                      {quotesData.deleted && (
                        <>
                          <Descriptions.Item key="deletedBy" label="Deleted By" style={{ fontWeight: 600 }}>
                            {this.printUserFullNameLink(quotesData)}
                          </Descriptions.Item>
                          <Descriptions.Item key="deletedAt" label="Deleted At" style={{ fontWeight: 600 }}>
                            {quotesData.deletedAt
                              ? moment
                                  .utc(quotesData.deletedAt)
                                  .locale("en")
                                  .local()
                                  .format("dddd, MMMM Do YYYY, h:mm a")
                              : ""}
                          </Descriptions.Item>
                          <Descriptions.Item key="deletedReason" label="Deleted Reason" style={{ fontWeight: 600 }}>
                            {quoteDeletetionReasonsMap[quotesData.deletedReason] || ""}
                          </Descriptions.Item>
                        </>
                      )}
                    </React.Fragment>
                  )}
                </Descriptions>
              </Card>
            </Col>
            <Col {...grid}>
              <Card type="inner" title="Dealer" style={{ height: "100%" }} headStyle={cardHead} className={"noPadding"}>
                <Descriptions
                  style={{
                    marginBottom: 32,
                  }}
                  column={1}
                  bordered
                >
                  <Descriptions.Item key="dealer" label="Dealer" style={{ fontWeight: 600 }}>
                    {quotesData.vehicle.shipment ? (
                      quotesData.vehicle.shipment.entity.name
                    ) : (
                      <Alert message="No shipment available" type="info" showIcon />
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item key="address" label="Address" style={{ fontWeight: 600 }}>
                    {quotesData.vehicle.shipment ? (
                      <p>
                        {`${quotesData.vehicle.shipment.entity.addressLine1}`}
                        <br />
                        {`${quotesData.vehicle.shipment.entity.city}, ${quotesData.vehicle.shipment.entity.state} ${quotesData.vehicle.shipment.entity.zipCode}`}
                      </p>
                    ) : (
                      <Alert message="No shipment available" type="info" showIcon />
                    )}
                  </Descriptions.Item>

                  <Descriptions.Item key="phone" label="Phone" style={{ fontWeight: 600 }}>
                    {quotesData.vehicle.shipment ? (
                      formatPhoneNumber(quotesData.vehicle.shipment.entity.phoneNumber1)
                    ) : (
                      <Alert message="No shipment available" type="info" showIcon />
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item key="distanceInMiles" label="Distance in Miles" style={{ fontWeight: 600 }}>
                    {quotesData.vehicle.shipment ? (
                      quotesData.vehicle.shipment.distanceInMiles
                    ) : (
                      <Alert message="No shipment available" type="info" showIcon />
                    )}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="space-between">
            <Col {...grid}>
              <Card
                type="inner"
                title="Vehicle"
                style={{ height: "100%" }}
                headStyle={cardHead}
                className={"noPadding"}
              >
                <VehicleDescription bordered vehicle={quotesData} column={1} style={{ marginBottom: 32, padding: 0 }} />
              </Card>
            </Col>
            <Col {...grid}>
              <Card
                type="inner"
                title="Shipment"
                style={{ height: "100%" }}
                headStyle={cardHead}
                className={"noPadding"}
              >
                <VehicleDescription bordered column={1} style={{ marginBottom: 32 }} vehicle={quotesData.vehicle} />
              </Card>
            </Col>
          </Row>
          {/* can only display map and steps if vehicle for quote is attached to a shipment */}
          {hasShipment && (
            <>
              <Divider
                style={{
                  marginBottom: 32,
                }}
              />
              <Steps
                style={{
                  marginBottom: 32,
                }}
              >
                <Step
                  status="finish"
                  title="Pickup"
                  description={
                    quotesData.vehicle.shipment
                      ? `${quotesData.vehicle.shipment.pickupAddressLine1} ${quotesData.vehicle.shipment.pickupCity}, ${quotesData.vehicle.shipment.pickupState} ${quotesData.vehicle.shipment.pickupZipCode}`
                      : ""
                  }
                  icon={<EnvironmentOutlined style={{ color: "#4888F4" }} />}
                />
                <Step
                  status="finish"
                  title="Drop off"
                  description={
                    quotesData.vehicle.shipment
                      ? `${quotesData.vehicle.shipment.dropoffAddressLine1} ${quotesData.vehicle.shipment.dropoffCity}, ${quotesData.vehicle.shipment.dropoffState} ${quotesData.vehicle.shipment.dropoffZipCode}`
                      : ""
                  }
                  icon={<EnvironmentOutlined style={{ color: "#DD4B3E" }} />}
                />
              </Steps>

              <div style={{ height: 400 }}>
                <GoogleMapReact
                  bootstrapURLKeys={{ key: GOOGLE_API_KEY }}
                  defaultCenter={{
                    lat: this.midPintCalculation(
                      quotesData.shipment.pickupLatitude,
                      quotesData.shipment.dropoffLatitude,
                    ),
                    lng: this.midPintCalculation(
                      quotesData.shipment.pickupLongitude,
                      quotesData.shipment.dropoffLongitude,
                    ),
                  }}
                  defaultZoom={10}
                  yesIWantToUseGoogleMapApiInternals
                  onGoogleApiLoaded={({ map, maps }) => this.extraMapRenders(map, maps)}
                ></GoogleMapReact>
              </div>
            </>
          )}
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default connect(({ quotesView, loading, configs }) => ({
  quotesView,
  loadingByVehicleId: loading.effects["quotesView/fetchSingleQuoteByVehicleId"],
  loadingByQuoteId: loading.effects["quotesView/fetchSingleQuoteByQuoteId"],
  configPerm: configs.configPerm,
}))(SingleQuote);
